import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { Container, Row, Col, Card } from 'react-bootstrap'
import Slider from 'react-slick'
import ProductSlider from './ProductSlider'
import './styles.scss'
import imageNotFound from 'src/images/imageNotFound.png'
import { catalogContainer } from 'src/models/Catalog'
import { pageNames } from 'src/routes/pathParams'
import { Link } from 'react-router-dom'
import { i18nTranslate, currencyFormat } from 'src/utils'
import { getImageFromProperty } from 'src/utils/commonUtils'

@observer
class BundlesWithThisItems extends React.Component {
  @observable isExpanded = false
  @observable bundleItems = []
  @observable showHeader = false

  getSearchBundlesAndKits = async productId => {
    const stringToPass = `{"filters":[{"field":"index_key_bundleskuids","operation":"IN","value":"${productId}"}]}`
    const response = await catalogContainer?.getSearchBundlesAndKits(
      stringToPass,
      1,
      6
    )
    return response?.product || []
  }

  handleToggleExpand = () => {
    this.isExpanded = !this.isExpanded
  }

  constructor(props) {
    super(props)
    this.state = {
      isMobile: typeof window !== 'undefined' ? window.innerWidth < 768 : false,
    }
  }

  async componentDidMount() {
    const temp = this?.props?.product
    const responseData = await this.getSearchBundlesAndKits(temp.productId)
    if (responseData && responseData.length > 0) this.showHeader = true
    this.bundleItems = responseData
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleResize)
      this.handleResize()
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleResize)
    }
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth < 768 })
  }

  render() {
    const { isMobile } = this.state
    let mobileVisibleItems = this.isExpanded
      ? this.bundleItems
      : this.bundleItems.slice(0, 5)
    const mobileRemainingCount = this.isExpanded
      ? 0
      : this.bundleItems.length - 5

    let mobileSliderItems = [...mobileVisibleItems]
    if (!this.isExpanded && mobileRemainingCount > 0) {
      mobileSliderItems.push({
        id: 'show-more',
        isShowMore: true,
        count: mobileRemainingCount,
      })
    }

    if (!this.showHeader) {
      return <></>
    }

    return (
      <div
        className="bundles-with-this-items"
        data-test-id="qa-bundles-with-this-items"
        role="region"
        aria-label={i18nTranslate(
          'kit_and_or_bundle.bundle_item',
          'Bundles with this item',
          {
            nameSpace: 'ssr-resource',
          }
        )}>
        <Container fluid className="px-0">
          {this.showHeader && (
            <h2
              className="bundles-title mb-3"
              data-test-id="qa-bundles-title"
              tabIndex={0}
              aria-label={i18nTranslate(
                'kit_and_or_bundle.bundle_item',
                'Bundles with this item',
                {
                  nameSpace: 'ssr-resource',
                }
              )}>
              {i18nTranslate(
                'kit_and_or_bundle.bundle_item',
                'Bundles with this item',
                {
                  nameSpace: 'ssr-resource',
                }
              )}
              {':'}
            </h2>
          )}
          {isMobile ? (
            <ProductSlider
              items={mobileSliderItems?.map(item => {
                if (item.isShowMore) {
                  return {
                    ...item,
                    isShowMore: true,
                  }
                }
                const imageUrl =
                  getImageFromProperty(item?.properties) || imageNotFound
                const priceObj =
                  item?.totalValue?.priceAfterDiscount ||
                  item?.totalValue?.price
                    ? item.totalValue
                    : item?.prices?.[0] || {}

                const price =
                  priceObj.priceAfterDiscount ?? priceObj.price ?? ''
                const formattedPrice = price
                  ? currencyFormat({
                      price,
                    })
                  : ''
                return {
                  ...item,
                  imageUrl,
                  name: item?.properties?.name || 'Bundle product image',
                  formattedPrice,
                }
              })}
              onShowMore={this.handleToggleExpand}
              data-test-id="qa-product-slider"
              aria-label="Product bundles slider"
            />
          ) : (
            <Row
              className="bundle-items-row"
              style={
                this.isExpanded
                  ? {
                      display: 'grid',
                      gridTemplateColumns: 'repeat(4, 0.2fr)',
                      gap: '2px',
                    }
                  : {}
              }
              data-test-id="qa-bundle-items-row"
              role="list"
              aria-label="Bundle items list">
              {(this?.isExpanded
                ? this?.bundleItems
                : this?.bundleItems.slice(0, 3)
              )?.map(item => {
                const imageUrl =
                  getImageFromProperty(item?.properties) || imageNotFound
                const priceObj =
                  item?.totalValue?.priceAfterDiscount ||
                  item?.totalValue?.price
                    ? item.totalValue
                    : item?.prices?.[0] || {}
                const price =
                  priceObj.priceAfterDiscount ?? priceObj.price ?? ''
                const formattedPrice = price
                  ? currencyFormat({
                      price,
                    })
                  : ''

                return (
                  <Col
                    key={item?.identifier}
                    xs={3}
                    className="bundle-item-col"
                    data-test-id={`qa-bundle-item-col-${item?.identifier}`}
                    role="listitem">
                    <Link
                      target="_blank"
                      rel="noopener noreferrer"
                      to={
                        pageNames.product +
                        '/' +
                        (item?.properties?.slug || item?.identifier)
                      }
                      className="image-container-wrap"
                      id={`product_card_img_${item?.properties?.slug || item?.identifier}`}
                      data-test-id={`qa-bundle-item-link-${item?.identifier}`}>
                      <Card
                        className="bundle-item-card"
                        data-test-id={`qa-bundle-item-card-${item?.identifier}`}>
                        <div className="bundle-image-container">
                          <Card.Img
                            variant="top"
                            src={imageUrl}
                            alt={
                              item?.properties?.name || 'Bundle product image'
                            }
                            className="bundle-item-image"
                            style={{
                              width: '80px',
                              height: '80px',
                              objectFit: 'cover',
                            }}
                            onError={e => {
                              e.target.src = imageNotFound
                            }}
                            data-test-id={`qa-bundle-item-image-${item?.identifier}`}
                          />
                        </div>
                        <Card.Body className="bundle-item-body">
                          <Card.Text
                            className="bundle-item-price"
                            data-test-id={`qa-bundle-item-price-${item?.identifier}`}>
                            {formattedPrice}
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </Link>
                  </Col>
                )
              })}
              {!this.isExpanded && this.bundleItems.length > 3 && (
                <Col
                  xs={3}
                  className="bundle-item-col"
                  data-test-id="qa-bundle-item-col-show-more"
                  role="listitem">
                  <Card
                    className="bundle-item-card more-items-card"
                    onClick={this.handleToggleExpand}
                    tabIndex={0}
                    role="button"
                    aria-label={`Show ${this.bundleItems.length - 3} more bundles`}
                    data-test-id="qa-more-items-card"
                    onKeyPress={e => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        this.handleToggleExpand()
                      }
                    }}>
                    <div className="bundle-image-container more-items-container">
                      <div className="more-items-content">
                        <span
                          className="more-items-text"
                          data-test-id="qa-more-items-text"
                          aria-label={`Show ${this.bundleItems.length - 3} more bundles`}>
                          +{this.bundleItems.length - 3}
                        </span>
                      </div>
                    </div>
                  </Card>
                </Col>
              )}
            </Row>
          )}
        </Container>
      </div>
    )
  }
}

export { BundlesWithThisItems }
export default BundlesWithThisItems
